export enum MEASURE_UNIT_WIND_LOAD {
  kn_m2 = 'kn_m2',
}

export enum MEASURE_UNIT_WIND_SPEED_ZONE {
  kn_m2 = 'kn_m2',
}
